var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigiInspectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FF6019",
    fillOpacity: 0.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 17.25H19.75C19.087 17.25 18.4511 17.5134 17.9822 17.9822C17.5134 18.4511 17.25 19.087 17.25 19.75V34.75C17.25 35.413 17.5134 36.0489 17.9822 36.5178C18.4511 36.9866 19.087 37.25 19.75 37.25H32.25C32.913 37.25 33.5489 36.9866 34.0178 36.5178C34.4866 36.0489 34.75 35.413 34.75 34.75V19.75C34.75 19.087 34.4866 18.4511 34.0178 17.9822C33.5489 17.5134 32.913 17.25 32.25 17.25H29.75",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 14.75H24.75C23.3693 14.75 22.25 15.8693 22.25 17.25C22.25 18.6307 23.3693 19.75 24.75 19.75H27.25C28.6307 19.75 29.75 18.6307 29.75 17.25C29.75 15.8693 28.6307 14.75 27.25 14.75Z",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 24.6367H22.2633",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4551 24.6367H30.0914",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 28.2725H22.2633",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 31.9092H22.2633",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4551 28.2725H30.0914",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4551 31.9092H30.0914",
    stroke: "#FF6019",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiInspectionIcon);
export default __webpack_public_path__ + "static/media/DigiInspectionIcon.7aa33b81.svg";
export { ForwardRef as ReactComponent };